type PolicyRuleResult = {
  Parameters?: {
    LowestFare?: { Result?: boolean };
    AcceptableFare?: { Result?: boolean };
  };
};

type PolicyTraveler = {
  Result: boolean;
  RulesResults?: PolicyRuleResult[];
};

type PolicyResult =
  | PolicyTraveler[]
  | {
      Result?: boolean;
      Badges?: { LowestFare?: boolean; AcceptableFare?: boolean };
    }
  | null
  | undefined;

export function policiesPassed(result: PolicyResult) {
  return Array.isArray(result)
    ? result.every((traveler) => traveler.Result)
    : result?.Result;
}

export function isLowestFare(result: PolicyResult) {
  return Array.isArray(result)
    ? result.some((traveler) =>
        traveler.RulesResults?.some(
          (rule) => rule.Parameters?.LowestFare?.Result === true
        )
      )
    : result?.Badges?.LowestFare === true;
}

export function isAcceptableFare(result: PolicyResult) {
  return Array.isArray(result)
    ? result.some((traveler) =>
        traveler.RulesResults?.some(
          (rule) => rule.Parameters?.AcceptableFare?.Result === true
        )
      )
    : result?.Badges?.AcceptableFare === true;
}
